import { createSelector } from 'reselect';

import { PARTNER_STATUSES } from './constants';

export const sortNewestFirstForProperty =
  (dateProperty: 'createdAt' | 'modifiedAt') =>
  (a, b): number => {
    const aDate = a[dateProperty];
    const bDate = b[dateProperty];
    if (bDate && aDate) {
      return new Date(bDate).getTime() - new Date(aDate).getTime();
    }
    if (bDate) {
      return 1;
    }
    if (aDate) {
      return -1;
    }
    return 0;
  };

export const sortNewestCreatedFirst = sortNewestFirstForProperty('createdAt');
export const sortNewestModifiedFirst = sortNewestFirstForProperty('modifiedAt');
export const sortNewestRejectedFirst = sortNewestModifiedFirst;

export const selectPartnersState = (state) => state.get('entities').partners;

export const selectPartners = createSelector(selectPartnersState, (partnersState) =>
  partnersState.get('partners')
);

export const selectPendingPartners = createSelector(selectPartners, (partners) =>
  partners
    .filter((partner) => partner?.status === PARTNER_STATUSES.pending)
    .sort(sortNewestCreatedFirst)
);

export const selectAcceptedPartners = createSelector(selectPartners, (partners) =>
  partners
    .filter((partner) => partner?.status === PARTNER_STATUSES.accepted)
    .sort(sortNewestModifiedFirst)
);

export const selectRejectedPartners = createSelector(selectPartners, (partners) =>
  partners
    .filter((partner) => partner?.status === PARTNER_STATUSES.rejected)
    .sort(sortNewestRejectedFirst)
);
